import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { BrandMark } from "@/components/Brand";
import { useUser } from "@/lib/userContext";

export default function AdminLogin() {
    const navigate = useNavigate();
    const { user, loading, signIn } = useUser();
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        if (loading) return;
        if (user?.is_admin) {
            navigate("/admin", { replace: true });
        } else {
            setChecking(false);
        }
    }, [user, loading, navigate]);

    if (loading || checking) {
        return (
            <div className="min-h-screen grid place-items-center bg-black">
                <Loader2 className="animate-spin text-saffron" size={28} />
            </div>
        );
    }

    return (
        <main className="min-h-screen relative bg-black grid place-items-center px-6" data-testid="admin-login">
            <div className="card-surface w-full max-w-md p-10 text-center">
                <div className="flex justify-center mb-6">
                    <BrandMark size={48} />
                </div>
                <div className="eyebrow text-saffron-brand mb-3">Aangan Theory · Admin</div>
                <h1 className="font-display text-3xl tracking-tighter mb-4">Sign in to continue.</h1>
                <p className="text-white/55 text-sm mb-10">
                    Restricted to internal administrators only. We use Google for sign-in.
                </p>
                <button onClick={() => signIn("/admin")} className="btn-primary w-full justify-center" data-testid="admin-google-login">
                    Continue with Google
                </button>
                {user && !user.is_admin && (
                    <p className="text-red-400/80 text-xs mt-6">
                        You are signed in as <span className="font-mono">{user.email}</span>, which does not have admin access.
                    </p>
                )}
                <p className="text-white/35 text-xs mt-8 leading-relaxed">
                    Access is granted only to allow-listed email addresses.
                </p>
            </div>
        </main>
    );
}
